import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import '../../style/Blog.css';

const PostCard = ({ post }) => {
  const { user } = useContext(AuthContext);

  return (
    <Card className="retro-post-card h-100 d-flex flex-column justify-content-between p-3">
      <Card.Body className="d-flex flex-column text-start justify-content-between">

        <Card.Title className="fw-bold text-center mb-3">
          {post.title}
        </Card.Title>

        <Card.Text className="text-muted text-justify mb-4 content-preview">
          {post.content.substring(0, 200)}...
        </Card.Text>

        <div className="post-meta mt-auto pt-2 border-top">
          <div className="mb-3 mt-3">
            <strong>Author:</strong>{' '}

            <Link
              to={user?.username === post.author.username ? "/profile" : `/profile/${post.author.username}`}
              className="author-link"
            >
              {post.author.username}
            </Link>

            <div>
              <strong>Published:</strong> {new Date(post.dateCreated).toLocaleDateString()}
            </div>
          </div>
          <Link
            to={`/posts/${post._id}`}
            className="retro-button small-btn w-100 text-center"
          >
            Read More
          </Link>
        </div>

      </Card.Body>
    </Card>
  );
};

export default PostCard;
